import React from "react";
import { useEffect } from "react";
import { useTable, usePagination } from "react-table";
import { ButtonA, ButtonPagination } from "../../styles-components/Buttons";
import { Table } from "../../styles-components/Table";
import { IoIosArrowForward, IoIosArrowBack } from "react-icons/io";
import { useRef } from "react";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import UseRedirectView from "../../utils/UseRedirectView";
import { BsFillTrashFill, BsPencilSquare, BsSearch } from "react-icons/bs";
// const route = process.env.MIX_APP_ROUTE;
// const route = process.env.MIX_APP_URL;

const TablePagination = ({
  orders,
  service,
  type,
  onDestroy,
  handleOpenModal,
  handleQuantityOrder,
  user,
}) => {
  // const history = useHistory();
  const columns = React.useMemo(
    () => [
      {
        Header: service,
        columns: [
          {
            Header: "DATA",
            accessor: "date",
          },
          {
            Header: "TOTAL",
            Cell: ({ cell }) => handleQuantityOrder(cell.row.original),
          },
          {
            Header: "OBSERVAÇÕES",
            accessor: "note",
          },
          {
            Header: "AÇÕES",
            Cell: ({ cell }) => {
              return cell.row.original.service_id == 47 ? (
                <div>
                  <ButtonA
                    as={"button"}
                    style={{ margin: "5px" }}
                    color="--white"
                    backgroundColor="--blue-icon"
                    onClick={() =>
                      handleOpenModal(cell.row.original.id, service)
                    }
                  >
                    <BsSearch />
                  </ButtonA>
                  <ButtonA
                    as={"button"}
                    style={{ margin: "5px" }}
                    color="--white"
                    backgroundColor="--red"
                    onClick={() => {
                      console.log("🤡");
                      onDestroy(cell.row.original.id);
                    }}
                  >
                    <BsFillTrashFill />
                  </ButtonA>
                </div>
              ) : (
                <div>
                  <ButtonA
                    as={"button"}
                    style={{ margin: "5px" }}
                    color="--white"
                    backgroundColor="--blue-icon"
                    onClick={() =>
                      handleOpenModal(cell.row.original.id, service)
                    }
                  >
                    <BsSearch />
                  </ButtonA>
                  {user === "nutri" ? (
                    <>
                      {[
                        30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 57, 58, 59,
                        60, 61, 62, 72,
                      ].find((id) => id == cell.row.original.service_id) ==
                        undefined && (
                        <ButtonA
                          as={"button"}
                          color="--white"
                          backgroundColor="--yellow"
                          onClick={() => {
                            console.log("😎");
                            UseRedirectView.to(
                              `formulario/pedidos/${cell.row.original.id}/edit`
                            );
                          }}
                        >
                          <BsPencilSquare />
                        </ButtonA>
                      )}
                      <ButtonA
                        as={"button"}
                        style={{ margin: "5px" }}
                        color="--white"
                        backgroundColor="--red"
                        onClick={() => {
                          console.log("🤡");
                          onDestroy(cell.row.original.id);
                        }}
                      >
                        <BsFillTrashFill />
                      </ButtonA>
                    </>
                  ) : (
                    cell.row.original.canBeDeleted && (
                      <>
                        {[
                          30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 57, 58,
                          59, 60, 61, 62, 72
                        ].find((id) => id == cell.row.original.service_id) ==
                          undefined && (
                          <ButtonA
                            as={"button"}
                            color="--white"
                            backgroundColor="--yellow"
                            onClick={() => {
                              console.log("😎");
                              UseRedirectView.to(
                                `formulario/pedidos/${cell.row.original.id}/edit`
                              );
                            }}
                          >
                            <BsPencilSquare />
                          </ButtonA>
                        )}
                        <ButtonA
                          as={"button"}
                          style={{ margin: "5px" }}
                          color="--white"
                          backgroundColor="--red"
                          onClick={() => {
                            console.log("🤡");
                            onDestroy(cell.row.original.id);
                          }}
                        >
                          <BsFillTrashFill />
                        </ButtonA>
                      </>
                    )
                  )}
                </div>
              );
            },
          },
          ,
        ],
      },
    ],
    []
  );

  const tableRef = useRef(null);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data: orders,
      initialState: { pageIndex: 0, pageSize: 15 },
    },
    usePagination
  );

  return (
    <>
      <Table ref={tableRef} {...getTableProps()} type={type}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps()}>{column.render("Header")}</th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row, i) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map((cell) => {
                  return (
                    <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </Table>

      <div>
        {/* <ButtonPagination onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
          {"<<"}
        </ButtonPagination> */}
        <ButtonPagination
          onClick={() => previousPage()}
          disabled={!canPreviousPage}
        >
          <IoIosArrowBack />
        </ButtonPagination>
        <ButtonPagination
          onClick={() => {
            tableRef.current.focus();
            nextPage();
          }}
          disabled={!canNextPage}
        >
          <IoIosArrowForward />
        </ButtonPagination>
        {/* <ButtonPagination onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
          {">>"}
        </ButtonPagination> */}
      </div>
    </>
  );
};

export default TablePagination;
